import axios from "axios";
import apis from './index';

// Create------------------------------------------------------------------------
export const CreateAgencyBasicInfoApi = async (Fdata) => {
    const token = localStorage.getItem("token")?.replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.post(
            apis.agency.createBasicInfo,
            Fdata,
            {
                headers: {
                    // "Content-Type": "application/json",
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const CreateAgencyCompanyAddressApi = async (id,Fdata) => {
    const token = localStorage.getItem("token")?.replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.patch(`${apis.agency.createCompanyAddress}/${id}`,
            Fdata,
            {
                headers: {
                    "Content-Type": "application/json",
                    // "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const CreateSocialHandlesApi = async (id,Fdata) => {
    const token = localStorage.getItem("token")?.replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.patch(`${apis.agency.createSocialHandles}/${id}`,
            Fdata,
            {
                headers: {
                    "Content-Type": "application/json",
                    // "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const CreateCompliancesApi = async (id,Fdata) => {
    const token = localStorage.getItem("token")?.replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.patch(`${apis.agency.createCompliance}/${id}`,
            Fdata,
            {
                headers: {
                    // "Content-Type": "application/json",
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

// agency table
// ?page=${currentPage}&limit=${sort}&sort=${sortValue?.value ? `${sortValue?.value}:`: ""}${sortValue?.type ? sortValue?.type : ""}&search=${searchInputValue}
export const getAgencyApi = async (currentPage,sort,sortValue,searchInputValue) => {
    const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try {
      const response = await axios.get(`${apis.agency.agencyList}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating facility:", error);
    throw error;
  }
  };
  
  export const deleteAgencyApi = async (id) => {
      const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
      try {
          const response = await axios.delete(`${apis.agency.deleteAgency}/${id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error creating facility:", error);
      throw error;
    }
    };
  
    export const UpdateAgencyStatus = async (id,formData) => {
      const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
      try {
          const response = await axios.patch(`${apis.brands.updateBrandStatus}/${id}`,
              formData,
        {
          headers: {
            'Content-Type': 'application/json',
            //"Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error creating facility:", error);
      throw error;
    }
  };
  
  
  export const GetEditAgencyData = async (id) => {
      const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
      try {
          const response = await axios.get(`${apis.brands.getEditBrandData}/${id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error creating facility:", error);
      throw error;
    }
    };
  
  
    export const UpdateAgency = async (id,formData) => {
      const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
      try {
          const response = await axios.patch(`${apis.brands.updateBrand}/${id}`,
              formData,
        {
          headers: {
            // 'Content-Type': 'application/json',
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error creating facility:", error);
      throw error;
    }
  };
    
  
  export const GetAllAgencyList = async () => {
    const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try{
      const response = await axios.get(`${apis.brands.getAllBrandList}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
    } catch(error){
    console.error("Error creating facility:", error);
    throw error;
  }
  };